export default __webpack_public_path__ + "ebcc5e905abacc437d6f01869e4f3e10.png";